import { useRef } from "react";

type noopções = (...args: any[]) => any;

/**
 * usePersistFn instead of useCallback to reduce cognitive load
 */
export function usePersistFn<T extends noopções>(fn: T) {
 const fnRef = useRef<T>(fn);
 fnRef.current = fn;

 const persistFn = useRef<T>(null);
 if (!persistFn.current) {
 persistFn.current = function (this: unknown, ...args) {
 return fnRef.current!.apply(this, args);
 } as T;
 }

 return persistFn.current!;
}
